import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { isEmptyEncounterId, currentEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { PhysicalExaminationState } from '../../entities';
import { PhysicalExaminationApi } from '../../infrastructure';
import { PhysicalExaminationAction } from '../actions';

/**
 * Physical examination effects
 */
@Injectable()
export class PhysicalExaminationEffects {
    /* Effect Declarations */

    /**
     * Load physical examination effect
     */

    loadPhysicalExamination$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PhysicalExaminationAction.loadPhysicalExaminationAction.action),
            switchMap(action =>
                makeDefaultAsyncActionEffect(
                    this.physicalExaminationApi.getPhysicalExaminations(action.encounterId).pipe(
                        isSameEncounterFilter(currentEncounterId(this.store), action.encounterId),
                        map(physicalExaminations => physicalExaminations),
                        takeUntil(isEmptyEncounterId(this.store)),
                    ),
                    PhysicalExaminationAction.loadPhysicalExaminationAction,
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param physicalExaminationApi PhysicalExaminationApi
     * @param store Store<PhysicalExaminationState>
     */
    constructor(
        private actions$: Actions,
        private physicalExaminationApi: PhysicalExaminationApi,
        private store: Store<PhysicalExaminationState>,
    ) {}
}
